import {
  Autocomplete,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import "../../sass/components/Filters/RequiredAvailabilityFilter.scss";

const HOURS_OPTIONS = ["3", "5", "10", "20", "40", "60", "80", "100"];
const FILTER_OPTIONS = ["Up to", "At least"];

export default function RequiredAvailabilityFilter({
  startValue,
  setStartValue,
  endValue,
  setEndValue,
  selectedOption,
  setSelectedOption,
  open,
  setOpen,
  title = "Weekly Availability",
  showFilterType = true,
  isAdd
}: {
  startValue: number;
  setStartValue: (newState: number) => void;
  endValue: number;
  setEndValue: (newState: number) => void;
  selectedOption: string;
  setSelectedOption: (newState: string) => void;
  open: boolean;
  setOpen: (key: string) => void;
  title?: string;
  showFilterType?: boolean;
  isAdd?:boolean
}) {
  const handleOpen = () => {
    setOpen("requiredAvailability");
  };

  return (
    <div className="component set_border_2_grey">
      <div onClick={handleOpen} className="title">
        <p>
          {title}&nbsp;
          {startValue > 0 && <span className="ml_3">({startValue} hours)</span>}
        </p>
        <i
          className={`${
            open && "rotate"
          } fa-solid fa-chevron-down cursor-pointer`}
        />
      </div>
      {open && (
        <div
          className="show_component"
          style={
            isAdd
              ? { left: 0, right: 0, borderLeft: 0, borderRight: 0 }
              : undefined
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px 0",
            }}
          >
            {/* Filter Type Selector */}
            {showFilterType && (
              <FormControl style={{ flex: 1, minWidth: 0 }}>
                <Select
                  value={selectedOption || "Up to"}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  style={{
                    borderRadius: 4,
                    background: "#fff",
                    fontSize: "10px",
                    height: "20px !important",
                    lineHeight: "20px !important",
                    minHeight: "20px !important",
                    maxHeight: "20px !important",
                  }}
                  size="small"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 100,
                        fontSize: "10px",
                        zIndex: 99999,
                      },
                    },
                    sx: {
                      zIndex: 99999,
                    },
                  }}
                >
                  {FILTER_OPTIONS.map((option) => (
                    <MenuItem
                      key={option}
                      value={option}
                      style={{
                        fontSize: "10px",
                        height: "20px",
                        lineHeight: "20px",
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {/* Hours Input */}
            <Autocomplete
              freeSolo={false}
              options={HOURS_OPTIONS}
              value={
                HOURS_OPTIONS.includes(startValue?.toString())
                  ? startValue?.toString()
                  : null
              }
              onChange={(_, val) => {
                if (!val) {
                  setStartValue(0);
                } else {
                  const num = Number(val);
                  setStartValue(!isNaN(num) && num > 100 ? 100 : num);
                }
              }}
              onInputChange={(_, value, reason) => {
                if (value === "" || value === undefined) {
                  setStartValue(0);
                } else {
                  const num = Number(value);
                  if (!isNaN(num) && num > 100) {
                    setStartValue(100);
                  } else {
                    setStartValue(Number(value));
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Hours"
                  type="number"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      borderRadius: 4,
                      background: "#fff",
                      fontSize: "10px",
                      height: "20px !important",
                      lineHeight: "20px !important",
                      minHeight: "20px !important",
                      maxHeight: "20px !important",
                    },
                  }}
                  style={{
                    borderRadius: 4,
                    background: "#fff",
                    fontSize: "10px",
                  }}
                  onKeyDown={(e) => {
                    const input = e.currentTarget as HTMLInputElement;
                    if (
                      (e.key === "Backspace" || e.key === "Delete") &&
                      input.value === ""
                    ) {
                      setStartValue(0);
                    }
                    if (e.key === "Enter") {
                      if (input.value === "") {
                        setStartValue(0);
                      } else if (Number(input.value) > 100) {
                        setStartValue(100);
                      }
                    }
                  }}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 100,
                  borderRadius: 4,
                  fontSize: "10px",
                  zIndex: 99999,
                },
              }}
              slotProps={{
                popper: {
                  sx: {
                    zIndex: 99999,
                  },
                },
              }}
              style={{ flex: 1, minWidth: 0 }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
